export * as userCertifications from '@wix/auto_sdk_user-certifications_user-certifications/meta';
